export default __webpack_public_path__ + "static/media/logo.255a9d60.png";